import { ReactNode } from "react";
import SpinnerLoader from "./spinner-loader";

export default function PrimaryButtonGradient({
  name = "",
  onClick,
  isLoading = false,
  fullWidth = false,
  padding = "10px 10px",
  margin = "0px",
  showArrow = false,

  arrowIcon,
  secondary = false,
  fontSize = "16.44px",
  borderRadius = "5.48px",
  removeBorder = false,
  isDisabled = false,
  fontWeight = "500",
  classNameDiv = "",
  classNamePrimaryDisabled = "",
  classNamePrimaryIsLoading = "",
  classNameBackgroundStyleSecondary = "",
  classNameBackgroundStylePrimaryGradient = "",
}: {
  name: any;
  onClick: Function;
  isLoading?: boolean;
  fullWidth?: boolean;
  padding?: string;
  removeBorder?: boolean;
  margin?: string;
  fontSize?: string;
  showArrow?: boolean;
  secondary?: boolean;
  borderRadius?: string;
  isDisabled?: boolean;
  fontWeight?: string;
  arrowIcon?: ReactNode;
  classNameDiv?: string;
  classNamePrimaryDisabled?: string;
  classNamePrimaryIsLoading?: string;
  classNameBackgroundStyleSecondary?: string;
  classNameBackgroundStylePrimaryGradient?: string;
}) {
  return (
    <div
      className="parent-gredient-button"
      onClick={() => {
        if (!isDisabled && !isLoading) {
          onClick();
        }
      }}
      style={{
        pointerEvents: isLoading ? "none" : "auto",
        margin: margin,
        textAlign: "center",

        cursor: `${isDisabled ? "unset" : "pointer"}`,
        display: fullWidth ? "block" : "flex",
        justifyContent: "center",
        fontWeight: fontWeight,
        ...(fullWidth ? { width: "100%" } : {}),
      }}
    >
      <div
        className={`${classNameDiv}  div-gredient-button noselect ${
          isDisabled
            ? `${classNamePrimaryDisabled} buttonBackgroundStylePrimaryDisabled`
            : isLoading
            ? `${classNamePrimaryIsLoading} buttonBackgroundStylePrimaryIsLoading`
            : secondary
            ? `${classNameBackgroundStyleSecondary} buttonBackgroundStyleSecondary`
            : `${classNameBackgroundStylePrimaryGradient} buttonBackgroundStylePrimaryGradient`
        }`}
        style={{
          borderRadius: borderRadius,
          border: !removeBorder
            ? secondary
              ? "1.4px solid var(--LightTheme-Primary)"
              : "none"
            : "none",

          color: secondary ? "var(--LightTheme-Primary)" : "white",
          padding: padding,
          fontSize: fontSize,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isLoading && (
          <div
            style={{
              width: "20px",
              height: "20px",
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <SpinnerLoader />
          </div>
        )}
        {<div className="login-button-text"> {name}</div>}
        <div
          style={{ display: showArrow ? "block" : "none", marginLeft: "5px" }}
        >
          {!isLoading &&
            (!arrowIcon ? (
              <i
                className="bi bi-arrow-right"
                style={{
                  color: secondary ? "var(--LightTheme-Secondary)" : "white",
                }}
              ></i>
            ) : (
              arrowIcon
            ))}
        </div>
      </div>
    </div>
  );
}
